<template>
    <b-modal no-close-on-backdrop no-close-on-esc hide-footer centered v-model="localModalShow"
        title="Pendências do Cadastro">
        <div>
            <p class="modal-text">
                Para que o cadastro seja considerado <b>completo</b>, por favor, clique nos itens
                abaixo para ser direcionado à edição:
            </p>
        </div>

        <b-list-group flush>
            <b-list-group-item v-for="(pendencia, index) in pendencias" :key="index"
                class="d-flex align-items-center text-custom-blue" role="button" @click="abrirEdicao(pendencia)">
                <feather-icon :icon="pendencia.icon" size="18" class="mr-2" />
                <span>{{ pendencia.label }}</span>
            </b-list-group-item>
        </b-list-group>

        <div class="border-top pt-1 d-flex justify-content-end">
            <b-button variant="primary-button" @click="cancelAction">
                <span class="align-middle">Fechar</span>
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import {
    BModal,
    BButton,
    BListGroup,
    BListGroupItem
} from 'bootstrap-vue';
export default {
    components: {
        BModal,
        BButton,
        BListGroup,
        BListGroupItem
    },

    props: {
        modalShow: {
            required: true,
            type: Boolean
        },
        empresa: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            localModalShow: this.modalShow
        }
    },

    computed: {
        pendencias() {
            const empresa = this.empresa || {};

            const rules = [
                {
                    valid: () => empresa.cnpj || empresa.cpf,
                    pendencia: { label: "CNPJ ou CPF", icon: "EditIcon" }
                },
                {
                    valid: () => empresa.razao_social || empresa.nome,
                    pendencia: { label: "Razão Social / Nome", icon: "EditIcon" }
                },
                {
                    valid: () => empresa.cpf || empresa.nome_fantasia,
                    pendencia: { label: "Nome Fantasia", icon: "EditIcon" }
                },
                {
                    valid: () => empresa.cnae,
                    pendencia: { label: "CNAE Principal", icon: "EditIcon", tab: "dados-complementares" }
                },
                {
                    valid: () => empresa.id_tipo_empresa,
                    pendencia: { label: "Tipo de Empresa", icon: "EditIcon", tab: "dados-complementares" }
                },
                {
                    valid: () => empresa.enderecos && empresa.enderecos.length > 0,
                    pendencia: { label: "Endereço", icon: "MapPinIcon", tab: "endereco" }
                },
                {
                    valid: () => empresa.empresa_contato_principal && empresa.empresa_contato_principal.length > 0,
                    pendencia: { label: "Contato Principal", icon: "PhoneIcon", tab: "contato" }
                },
                {
                    valid: () => empresa.id_termo,
                    pendencia: { label: "Aceite do Termo de Compartilhamento de Dados", icon: "EyeIcon", tab: "termo" }
                },
                {
                    valid: () => empresa.id_tipo_empresa !== 1 || !empresa.cnae || empresa.situacao === "Aprovada",
                    pendencia: { label: "Validação do CNAE pelo SESI", icon: "CheckIcon", tab: "dados-complementares" }
                },
                {
                    valid: () => empresa.total_colaboradores && empresa.total_colaboradores > 0,
                    pendencia: { label: "Cadastrar pelo menos 1 colaborador", icon: "UserIcon", tab: "termo" }
                }
            ];

            const pendencias = rules
                .filter(rule => !rule.valid())
                .map(rule => rule.pendencia);

            return pendencias;
        }
    },

    methods: {
        abrirEdicao(pendencia) {
            this.$emit('confirmed', pendencia.tab);
        },

        cancelAction(modalEvent) {
            if (modalEvent) modalEvent.preventDefault();
            this.$emit("canceled", modalEvent);
        }
    },

    watch: {
        modalShow(val) {
            this.localModalShow = val;
        },
        localModalShow(val) {
            if (!val) {
                this.$emit("canceled");
            }
        }
    }
}
</script>
